export default function cleanLink(link, isBlog) {
  const _link = link?.replace("https://", "")?.split("/")?.splice(isBlog ? 2 : 1)?.join("/");
  // console.log('URL ENTERA', link);
  // console.log('URL SLUG IDIOMAS', _link);
  return _link;
}